import { Suspense, lazy } from 'react';
import { Navigate } from 'react-router-dom';

import SuspenseLoader from 'src/components/SuspenseLoader';

const Loader = (Component) => (props) =>
  (
    <Suspense fallback={<SuspenseLoader />}>
      <Component {...props} />
    </Suspense>
  );

// Dashboards

const AdminDashboard = Loader(
  lazy(() => import('src/content/reception/report'))
);
const UserDashboard = Loader(
  lazy(() => import('src/content/dashboards/ccs/user'))
);
const Reports = Loader(lazy(() => import('src/content/dashboards/Reports')));
const Analytics = Loader(lazy(() => import('src/content/reception/reports')));
const Proforma = Loader(lazy(() => import('src/content/reception/proforma')));


const dashboardsRoutes = [
  {
    path: '',
    element: <AdminDashboard />
  },
  {
    path: 'admin',
    element: <AdminDashboard />
  },
  {
    path: 'user',
    element: <UserDashboard />
  },
  {
    path: 'reports',
    element: <Reports />
  },
  {
    path: 'analytics',
    element: <Analytics />
  },
  {
    path: 'proforma',
    element: <Proforma />
  },

];

export default dashboardsRoutes;
